import type { DataAttributes } from 'shared/lib/data-auto-test';
import { MaterialIcon } from 'shared/ui/MaterialIcon';
import { Button } from 'shared/ui/Button';
import { useModalsActions } from 'shared/ui/SideModal';
import type { HistoryFetcher, HistoryTableColumns } from 'entities/history';

import { HistoryModal } from './HistoryModal';

interface ShowHistoryProps extends DataAttributes {
  text: string;
  iconName: 'history' | 'history_toggle_off';
  useGetHistory: HistoryFetcher;
  historyTableColumns: HistoryTableColumns;
  buttonText?: string;
  onClick?: () => void;
  autoTestAttributesName?: string;
}

export function ShowHistory({
  text,
  iconName,
  useGetHistory,
  historyTableColumns,
  buttonText = 'See all',
  onClick,
  attributes,
  autoTestAttributesName,
}: ShowHistoryProps) {
  const { open } = useModalsActions();

  const openHistoryModal = () => {
    open(
      <HistoryModal
        title={text}
        useGetHistory={useGetHistory}
        historyTableColumns={historyTableColumns}
        autoTestAttributesName={autoTestAttributesName}
      />
    );
    onClick?.();
  };

  return (
    <>
      <div className="border-t border-slate-100" />
      <div className="my-6 flex items-center justify-between">
        <div className="flex justify-center">
          <MaterialIcon className="pr-3 text-lg">{iconName}</MaterialIcon>
          <div className="text-lg font-semibold">{text}</div>
        </div>
        <Button
          dataTestId="button-show-history"
          type="button"
          onClick={openHistoryModal}
          variant="outline"
          size="medium"
          {...attributes}
        >
          {buttonText}
        </Button>
      </div>
    </>
  );
}
